import Grid from '@mui/material/Grid';
import AgyleTextField from '../../../../components/ui/fields/agyleTextField';
import React from 'react';

export const triageBase = () => {
    return {
        who: null,
        whoUserName: null,
        when: null,

        triageClinicians: null,

        presentation: null,
        discriminator: null,
        dependency: null,
        dependencyTriage: null,

        analgesia: false,
        analgesiaRefused: false,
        analgesiaDetails: '',

        analgesiaPrior: false,
        analgesiaPriorDetails: '',

        analgesiaSAT: false,
        analgesiaSATDetails: '',

        chiefComplaint: null,
        chiefComplaintAuthor: '',

        safeguardingConcerns: false,
        safeguardingConcernsDetails: '',
        safeguarding: [],

        childProtectionConcerns: false,
        childConcernsDetails: '',

        patientWeight: '',
        patientWeightUnits: 'kg',
        presentingComplaint: '',
        presentingComplaintAuthor: '',
        historicPresentingComplaint: '',
        historicPresentingComplaintAuthor: '',
        pastMedicalHistory: null,
        pastMedicalHistoryAuthor: null,
        allergies: null,
        allergiesAuthor: null,
        medications: null,
        medicationsAuthor: null,
        socialHistory: null,

        examination: '',

        investigations: [],
        investigationsTriage: [],

        investigationsDetails: '',
        treatmentAndManagementPlan: [],
        treatmentAndManagementPlanTriage: [],

        treatmentAndManagementPlanDetails: '',
        additionalInformation: '',

        observationNotRequired: false,
        observationNotRequiredTimestamp: null,
        savedObservationId: null,

        painScore: 0,
        painScoreId: '',

        firstWho: null,
        firstWhoUserName: null,
        firstWhen: null,
        firstDiscriminator: null,
    };
};

export const renderDiscriminationDescription = (triageObj, dark) => {
    const discriminatorDetails = triageObj?.discriminator?.details;

    if (discriminatorDetails)
        return (
            <Grid item xs={12}>
                <AgyleTextField
                    disabled
                    fullWidth
                    style={{width: '100%'}}
                    label="Discriminator description"
                    type="string"
                    value={discriminatorDetails}
                    variant="outlined"
                    multiline
                    sx={{
                        '& .MuiInputBase-input.Mui-disabled': {
                            cursor: 'text',
                            pointerEvents: 'auto',
                            WebkitTextFillColor: dark ? 'white' : 'black',
                        },
                        '& .MuiFormLabel-root.MuiInputLabel-root.Mui-disabled':
                            {WebkitTextFillColor: dark ? 'rgba(255, 255, 255, 0.7)' : 'black'},
                    }}
                    size="large"
                    noBorder={false}
                    withNewBackground
                />
            </Grid>);
};